<template>
  <div>
      <h2>サイトマップ用</h2>
        <div>
            <div v-for="article in articles" :key="article.id">
              &lt;url&gt;
              <br>&lt;loc&gt;
                https://dream.ameneko.com/article/{{article.title}}
                &lt;/loc&gt;   
              <br>&lt;/url&gt;
          </div>
        </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
    data(){
        return{
        articles: [],
        }
    },
    mounted() {
        this.fetchNotice();
        const title = "リスト一覧｜夢占い辞典ゆめみん"
        const description = "夢占い辞典ゆめみんのリスト一覧です"
        const twitter_image = 'https://dream.ameneko.com/ogpImage.jpeg'
        const og_image = 'https://dream.ameneko.com/topImage.jpeg'
        document.title = title
        document.querySelector("meta[property='og:image']").setAttribute('content', og_image)
        document.querySelector("meta[name='twitter:image']").setAttribute('content', twitter_image)
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    },
    methods: {
    fetchNotice() {
      if(!this.$route.query.id){
        axios.get("https://dream.microcms.io/api/v1/article?limit=100", {
          headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
        }).then(res => {
          this.articles = res.data.contents;
        }).catch(err => {
          console.log(err);
        });
      }else{
        axios.get("https://dream.microcms.io/api/v1/article?" + "offset=" + this.$route.query.id + "&limit=100", {
          headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
        }).then(res => {
          this.articles = res.data.contents;
        }).catch(err => {
          console.log(err);
        });
      }
    },
  },

}
</script>

<style>
.articles{
  max-width: 500px;
  margin: auto;
  padding:20px;
}
h1{
  font-weight: bold;
  font-size: 1.2em;
  text-align: center;
  padding-bottom: 10px;
}
.article_title{
  font-size: 1.2em;
  padding:6px;
}
.next-page{
  padding:20px 0 20px 0;
  font-size: 1.2em;
}
</style>